import styled from 'styled-components';

const StyleProvider = styled.div`
`

export default StyleProvider;